export default {
    thresholds: {
        Person: 3,
        Company: 3,
        Index: 1,
        Topic: 1,
        Commodity: 1.5,
        City: 2,
        Fund: 1,
        Organization: 1,
        Country: 2,
        Currency: 2,
        Region: 3,
        Classification: 2,
        Location: 1,
        Event: 1,
    },
    targetingParamLimit: 20,
    contextTagTypesLimit: 1,
    confidenceThreshold: 0.25,
};
